import React from 'react';
import { useTranslation } from 'react-i18next';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import { getRelatedContentBlock } from '../../../DeviationViews/_helpers';
const TOOLTIP_WIDTH_PX = 256;
/** The owner's SubscribersOnly tooltip contains info about how many tiers
 *  contain the deviation and those tier titles that isn't used in the other tooltips. */ const SubscribersOnlyOwnersTooltip = ({ deviation, linkClassName, children })=>{
    var _getRelatedContentBlock;
    const { t } = useTranslation();
    const { tier, isTier, isOwner, subscriptionsTabUrl } = useSubscriptionTier(deviation);
    // no tooltip for tier deviation viewed by owner
    if (!tier || !isOwner || isTier) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    var _getRelatedContentBlock_deviations;
    // when the owner is viewing an in-tier, we show a list of the tiers
    // containing this deviation in the description and a count in the heading
    const inTiers = (_getRelatedContentBlock_deviations = (_getRelatedContentBlock = getRelatedContentBlock(deviation, 'in_tiers')) === null || _getRelatedContentBlock === void 0 ? void 0 : _getRelatedContentBlock.deviations) !== null && _getRelatedContentBlock_deviations !== void 0 ? _getRelatedContentBlock_deviations : [];
    return /*#__PURE__*/ React.createElement(SophisticatedTooltip, {
        size: "large",
        placement: "top",
        width: TOOLTIP_WIDTH_PX,
        heading: t('deviation.tier.subscribersOnly.tooltip.owner.tierCount', {
            // note: the inTiers list includes the current tier
            count: inTiers.length
        }),
        description: inTiers.map((otherTier)=>otherTier.title).join('\n'),
        postfix: /*#__PURE__*/ React.createElement(SophisticatedTooltipLink, {
            href: subscriptionsTabUrl,
            className: linkClassName
        }, t('deviation.tier.subscribersOnly.tooltip.subscriptionsLinkOwner'))
    }, children);
};
SubscribersOnlyOwnersTooltip.displayName = 'SubscribersOnlyOwnersTooltip';
export default SubscribersOnlyOwnersTooltip;

//# sourceMappingURL=SubscribersOnlyOwnersTooltip.js.map